const DATA_TEST_IDS = {
  fragmentsDesktopList: 'module__users-list_fragments_desktop-list',
  fragmentsMobileList: 'module__users-list_fragments_mobile-list',
  fragmentsTabletList: 'module__users-list_fragments_tablet-list',
} as const;

export default DATA_TEST_IDS;
